/* eslint-disable no-new */
import merge from 'deepmerge'
import { Formik, getIn } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'

import { handleSubmitError, isConditional } from '../utils'
import CustomForm from './common/forms/CustomForm'
import FieldGroup from './common/forms/FieldGroup'
import { Button } from './ui/Button'
import { Scrollbar } from './ui/Scrollbars'


class P24UrlSidebar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      initvals: { ...props.autofill, active: true },
      fieldgroups: {
        'Property24 Listings': {}
      },
      fields: [
        {
          name: 'p24_urls',
          input: 'FieldArray',
          group: 'Property24 Listings',
          edit: true,
          text_suffix: 'P24 URL',
          max: props.max,
          multi: true,
          fields: [
            {
              name: 'url',
              label: 'Property24 URL',
              edit: true
            }
          ]
        }
      ]
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSubmitError = handleSubmitError.bind(this)
    this.isConditional = isConditional.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.max !== this.props.max) {
      const fieldarray = this.state.fields[0]
      fieldarray.max = this.props.max
      this.setState({ ...this.state, fields: [ fieldarray ] })
    }
  }

  componentWillUnmount() {
    this.props.actions.toggleWideSidebar()
  }

  handleSubmit(values) {
    new Promise((resolve, reject) => (this.props.actions.fetchP24Urls(values, resolve, reject))).then(r => {
      this.props.actions.updateOptions(r)
      this.props.actions.toggleWideSidebar()
    }).catch(() => {})
  }

  render () {
    const { modelname, parent, data } = this.props
    let values = getIn(data, parent.name, []) || []
    values = values.filter(v => v.url).map(v => ({ url: v.url }))
    return (
      <div id="contact-creator-sidebar" ref={el => { this.el = el }} className="wide-sidebar contact-creator-sidebar">
        <div className="wide-sidebar-container">
          <Formik
            initialValues={{
              modelname,
              p24_urls: values,
              endpoint: {
                read: '/listings/api/v1/p24-fetch/'
              }
            }}
            validateOnChange={false}
            validateOnBlur={true}
            onSubmit={this.handleSubmit}
            enableReinitialize={true}
          >{ formik => {
              this.form = formik
              return (
                <CustomForm
                  render={() => (
                    <div className="wide-sidebar-pane">
                      <div className="wide-sidebar-heading">
                        <h4>Add Properties</h4>
                        <Button
                          type="button"
                          icon="#icon24-X-Large"
                          className="btn btn-none btn-icon btn-icon-24 btn-wide-sidebar-close"
                          onClick={() => { this.props.actions.toggleWideSidebar() }}
                        />
                      </div>
                      <Scrollbar
                        style={{ height: 'calc(100vh - 218px)' }}
                        renderView={({ style, ...props }) => <div {...props} style={{ ...style, position: 'relative', height: 'calc(100% + 15px)' }} className="scrollview"/>}
                      >
                        <div className="wide-sidebar-content">
                          { Object.keys(this.state.fieldgroups).map((group, gidx) => (
                            <FieldGroup
                              key={`fs-${gidx}`}
                              groupname={group}
                              group={this.state.fieldgroups[group]}
                              gidx={gidx}
                              classes={this.state.fieldgroups[group].classes}
                              fields={this.state.fields.filter(field => field.group === group).map(f => {
                                const newfield = merge({}, f)
                                if (newfield.createnew) { newfield.createnew = false }
                                if (newfield.twin) { newfield.readonly = true }
                                return newfield
                              })}
                              modelname={modelname}
                              match={this.props.match}
                              required={this.state.required}
                              columns
                              collapsed={this.state.collapsed}
                              render={({ renderFieldGroup, hidden }) => {
                                if (hidden) { return null }
                                return (
                                  <fieldset className="editgroup">
                                    <h5>{group}</h5>
                                    {renderFieldGroup(group)}
                                  </fieldset>
                                )
                              }}
                            />
                          ))}
                          <div className="wide-sidebar-footer">
                            <Button
                              type="button" // This cannot be submit otherwise sibling form is submitted
                              onClick={formik.submitForm}
                              disabled={formik.isSubmitting}
                              className="btn btn-primary"
                            >
                              Add
                            </Button>
                          </div>
                        </div>
                      </Scrollbar>
                    </div>
                  )}
                />
              )
            }}
          </Formik>
        </div>
      </div>
    )
  }
}

P24UrlSidebar.propTypes = {
  config: PropTypes.object,
  field: PropTypes.object,
  siblingform: PropTypes.object,
  actions: PropTypes.object,
  autofill: PropTypes.object,
  match: PropTypes.object,
  user: PropTypes.object,
  cache: PropTypes.object,
  sidebar: PropTypes.string,
  selectContact: PropTypes.func,
  toggleLookup: PropTypes.func,
  modelname: PropTypes.string,
  max: PropTypes.number,
  data: PropTypes.object,
  parent: PropTypes.object
}

export default P24UrlSidebar
